import BaseController from '../base';

export default class CommonUiController extends BaseController {

  get elementsIdPrefix() {
    return 'common_ui'
  }
}
